module.exports = __webpack_public_path__ + "static/media/totalPublishedLights.acd40352.svg";